export default {
  brand: 'CrypPay',
  transferHint: 'कृपया नीचे दिए गए पते पर ट्रांसफर करें',
  rechargeAmount: 'रिचार्ज राशि',
  rechargeAddress: 'रिचार्ज पता',
  scanTip: 'अपने वॉलेट से QR कोड स्कैन करके भुगतान करें',
  copy: 'कॉपी करें',
  copied: 'कॉपी हो गया',
  copyFail: 'कॉपी करने में विफल',
  networkFee: 'नेटवर्क शुल्क',
  eta: 'अनुमानित समय',
  etaVal: '5-15 मिनट',
  actualArrival: 'आपको प्राप्त होगा',
  noticeTitle: 'महत्वपूर्ण सूचना',
  notice1: 'कृपया केवल इस पेज पर दिखाए गए QR कोड या पते पर ही ट्रांसफर करें। गलत पते पर भेजी गई राशि वापस नहीं की जा सकती।',
  notice2: 'ट्रांसफर राशि बिल्कुल {amount} {coin} होनी चाहिए, राशि अलग होने पर ऑटो क्रेडिट नहीं होगा।',
  notice3: 'ब्लॉकचेन कन्फर्मेशन का इंतजार करें (आमतौर पर 1 कन्फर्मेशन के बाद क्रेडिट हो जाता है)।',
  notice4: 'ऑन-चेन ट्रांसफर रद्द नहीं किया जा सकता। उपयोगकर्ता की गलती से हुए नुकसान की जिम्मेदारी उपयोगकर्ता की होगी।',
  selectLang: 'भाषा चुनें',
  pending: 'लंबित भुगतान',
  paid: 'भुगतान हो गया',
  timeout: 'समय समाप्त',
  orderNo: 'ऑर्डर नंबर',
  loading: 'लोड हो रहा है…',
  paramError: 'लिंक पैरामीटर अधूरा है',
  initFail: 'ऑर्डर बनाने में विफल',
  paidSuccess: 'भुगतान सफल',
  timedOut: 'ऑर्डर समाप्त हो गया है, कृपया पुनः प्रयास करें'
}